import {
  Badge,
  Box,
  Button,
  Center,
  Flex,
  Heading,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import { ArrowRightIcon, DownloadIcon } from "@radix-ui/react-icons";
import { Link as RouterLink } from "react-router-dom";
import { routes } from "../routes";
import { useAdminContext } from "./admin-context";

export function AdminStationsPage() {
  const { role, stations } = useAdminContext();

  return (
    <Stack spacing="8">
      <Flex
        align={{ base: "flex-start", md: "center" }}
        justify="space-between"
        direction={{ base: "column", md: "row" }}
        gap="3"
      >
        <Box>
          <Heading size="xl">
            {role === "superAdmin" ? "Alle Stationen" : "Meine Stationen"}
          </Heading>
          <Text color="gray.600" mt="2">
            Stationen, auf die Sie als Administrator zugreifen können.
          </Text>
        </Box>
        <Badge colorScheme="blue" fontSize="sm" px="3" py="1">
          {stations.length} {stations.length === 1 ? "Station" : "Stationen"}
        </Badge>
      </Flex>

      {stations.length === 0 ? (
        <Center
          minH="240px"
          bg="white"
          borderWidth="1px"
          borderRadius="lg"
          px="6"
        >
          <Stack align="center" spacing="2" textAlign="center">
            <Heading size="md">Keine Station zugewiesen</Heading>
            <Text color="gray.600" maxW="lg">
              Ein Super Admin muss diesem Konto zuerst mindestens eine Station
              zuweisen.
            </Text>
          </Stack>
        </Center>
      ) : (
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing="5">
          {stations.map((station) => (
            <Stack
              as="article"
              key={station.id}
              spacing="5"
              bg="white"
              borderWidth="1px"
              borderRadius="lg"
              p="6"
              boxShadow="sm"
            >
              <Box flex="1">
                <Text color="gray.500" fontSize="sm">
                  Station
                </Text>
                <Heading as="h2" size="md" mt="1">
                  {station.name}
                </Heading>
                <Text as="code" display="block" color="gray.600" mt="2">
                  {station.slug}
                </Text>
              </Box>
              <Button
                as={RouterLink}
                to={`${routes.admin.exports}?station=${encodeURIComponent(station.slug)}`}
                aria-label={`Export für ${station.name} öffnen`}
                leftIcon={<DownloadIcon />}
                rightIcon={<ArrowRightIcon />}
                colorScheme="blue"
                alignSelf="flex-start"
              >
                Export öffnen
              </Button>
            </Stack>
          ))}
        </SimpleGrid>
      )}
    </Stack>
  );
}
